import { getBrowserStorage } from '../BrowserStorage';
import { ReferenceIdContainer } from '../ReferenceIdContainer';
import { Type } from '../Type';

const BrowserStorageKeyJobVacancies = 'com.jobCenter.selectedJobVacancies';
export const BrowserStorageKeyHiddenDepartments = 'com.jobCenter.hiddenDepartments';


interface ReferenceIdBrowserStorageInterface {
    load(key: string): ReferenceIdContainer;

    load(type: Type): ReferenceIdContainer;

    store(key: string, container: ReferenceIdContainer): void

    store(type: Type, container: ReferenceIdContainer): void;

    clear(key: string): void;

    clear(type: Type): void;
}

export class ReferenceIdBrowserStorage implements ReferenceIdBrowserStorageInterface {
    private browserStorage: Storage;

    constructor(browserStorage?: Storage) {
        this.browserStorage = browserStorage || getBrowserStorage();
    }

    public load(typeOrKey: Type | string): ReferenceIdContainer {
        const key = this.getKeyForType(typeOrKey);
        const raw = this.browserStorage.getItem(key);
        if (!raw) {
            return new ReferenceIdContainer([]);
        } else {
            return new ReferenceIdContainer(raw.split(',').map(s => s.trim()).filter(s => s !== ''));
        }
    }

    public store(typeOrKey: Type | string, container: ReferenceIdContainer) {
        const key = this.getKeyForType(typeOrKey);
        this.browserStorage.setItem(key, container.identifiers.join(','));
    }

    public clear(typeOrKey: Type | string) {
        const key = this.getKeyForType(typeOrKey);
        this.browserStorage.removeItem(key);
    }

    private getKeyForType(typeOrKey: Type | string): string {
        if (typeOrKey === Type.JobVacancy) {
            return BrowserStorageKeyJobVacancies;
        } else {
            return typeOrKey;
        }
    }

}
